const Modes = {
    CREATE: 'create',
    CREATE_FINALISED: 'create-finalised',
    EDIT: 'edit',
    EDIT_FINALISED: 'edit-finalised',
    VIEW: 'view',
    DUPLICATE: 'duplicate',
    DELETE: 'delete',
};

const OrderTypes = {
    REGULAR: 'Regular',
    DH_BROKER: 'DH Broker',
    DH_GHOST: 'DH Ghost',
};

const OrderStatuses = {
    CLOSED: 'CLOSED',
    OPEN: 'OPEN',
    EXPIRED: 'EXPIRED',
};

const Intents = {
    SELL: 'SELL',
    BUY: 'BUY',
};

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export { Modes, OrderTypes, MONTHS, OrderStatuses, Intents };



// WEBPACK FOOTER //
// ./source/constants/order.js